export const WHATSAPP_WS_EVENT_TYPES = {
  CONVERSATION_CREATED: 'WHATSAPP_CONVERSATION_CREATED',
  MESSAGE_CREATED: 'WHATSAPP_MESSAGE_CREATED',
  MESSAGE_READ: 'WHATSAPP_MESSAGE_READ',
};

export const routeWhatsappWsEvent = (event, handlers = {}) => {
  if (!event || typeof event !== 'object') {
    if (typeof handlers.onInvalidEvent === 'function') {
      handlers.onInvalidEvent(event);
    }
    return;
  }

  const payload = event.payload && typeof event.payload === 'object' ? event.payload : {};

  switch (event.type) {
    case WHATSAPP_WS_EVENT_TYPES.CONVERSATION_CREATED:
      if (typeof handlers.onConversationCreated === 'function') {
        handlers.onConversationCreated({ event, payload });
      }
      return;
    case WHATSAPP_WS_EVENT_TYPES.MESSAGE_CREATED:
      if (typeof handlers.onMessageCreated === 'function') {
        handlers.onMessageCreated({ event, payload });
      }
      return;
    case WHATSAPP_WS_EVENT_TYPES.MESSAGE_READ:
      if (typeof handlers.onMessageRead === 'function') {
        handlers.onMessageRead({ event, payload });
      }
      return;
    default:
      if (typeof handlers.onUnknown === 'function') {
        handlers.onUnknown({ event, payload });
      }
  }
};
